import React, { PropTypes } from "react";
import { FormattedHTMLMessage, FormattedMessage, intlShape } from "react-intl";
import { connect } from "react-redux";
import moment from "moment";
import { Field, change as changeFieldValue, formValueSelector, reduxForm } from "redux-form";
import {
  CheckboxInput,
  DayPicker,
  IntlFieldGroup,
  SelectInput,
  TextInput,
} from "../../../../common/form";

import { bindActionCreators } from "redux";
import validationUtils from "../../../../../utils/ValidationUtils";
import { BILLING_PERIODS } from "../../../../../utils/data/models";
import { MessageBox } from "../../../../common";
import { getRetroactiveCredits } from "../../../../common/RetroactiveData/RetroactiveLimitHelper";
import { convertMonthsToYears } from "../../../../common/dateHelper";
import { MANUAL } from "../../enums/billingPeriodTypes";
import { BILLING_PERIODS_VALIDATION_RULES } from "./billingPeriodValidationRules";

class BasicBillingPeriodFields extends React.Component {
  static generateLocalizedRules(values, client, billingPeriodId, startDate) {
    let newRules = { ...BILLING_PERIODS_VALIDATION_RULES };
    const basicRules = {
      isRequiredTrim: {
        value: true,
      },
    };
    BILLING_PERIODS.localizedFields.map((field) => {
      Object.keys(values.localizations).map((locale) => {
        const fieldName = `localizations['${locale}'].${field}`;
        newRules[fieldName] = basicRules;
      });
    });
    
    const currentDate = moment.utc().subtract(1, "days");

    if (client) {
      if (client.clientBillingPeriodType === MANUAL.value) {
        if (!billingPeriodId || values.startDate && values.startDate.format("YYYY-MM-DD") <= currentDate) {
          newRules["startDate"] = {
            higherThanValue: {
              value: {
                value: currentDate,
                customMessageKey: "billingPeriods.form.error.startDateAfterCurrentDate",
              },
            },
          };
        } 
      }
      if (startDate && startDate != values.startDate) {
        newRules["startDate"] = {
          higherThanValue: {
            value: {
              value: currentDate,
              customMessageKey: "billingPeriods.form.error.startDateAfterCurrentDate",
            },
          },
        };
      }
      
      if (client.lastActiveDate && values.startDate && values.startDate.format("YYYY-MM-DD") >= client.lastActiveDate) {
        newRules["startDate"] = {
          higherThanValue: {
            value: {
              value: client.lastActiveDate,
              customMessageKey: "billingPeriods.form.error.startDateAfterLastActiveDate",
            },
          },
        };
      }

      if (client.lastActiveDate && values.endDate && values.endDate.format("YYYY-MM-DD") > client.lastActiveDate) {
        newRules["endDate"] = {
          higherThanValue: {
            value: {
              value: client.lastActiveDate,
              customMessageKey: "billingPeriods.form.error.endDateAfterLastActiveDate",
            },
          },
        };
      }
    }
    return newRules;
  }
  constructor(props, context) {
    super(props, context);
    this.generateLocalizedFields = this.generateLocalizedFields.bind(this);

    this.state = {
      retroactiveCredits: {},
      frequency: undefined,
      invoiceCount: undefined,
    };
    this.generateCreditsInvoiceFrequencyOptions = this.generateCreditsInvoiceFrequencyOptions.bind(this);
    this.setMaximumRetroactiveCredits = this.setMaximumRetroactiveCredits.bind(this);
    this.onChangeFrequency = this.onChangeFrequency.bind(this);
  }

  getChildContext() {
    return {
      scene: this.props.scene,
    };
  }

  componentDidMount() {
    const { clientCreditsInvoiceFrequency, clientCreditsInvoiceCount, add } = this.props;

    if (add) {
      this.props.changeFieldValue(
        "billingPeriod",
        "creditsInvoiceFrequency",
        clientCreditsInvoiceFrequency
      );
      this.props.changeFieldValue(
        "billingPeriod",
        "creditsInvoiceCount",
        clientCreditsInvoiceCount
      );
    }
    this.setState({
      frequency: add ? clientCreditsInvoiceFrequency : this.props.initialValues.creditsInvoiceFrequency,
      invoiceCount: add ? clientCreditsInvoiceCount : this.props.initialValues.creditsInvoiceCount,
    });
    this.setMaximumRetroactiveCredits();
  }

  static startDate = undefined;  
  static client = undefined;
  static billingPeriodId = undefined;

  generateLocalizedFields() {
    return BILLING_PERIODS.localizedFields.map((field) => {
      return (
        <IntlFieldGroup
          key={field}
          field={field}
          labelKey={`billingPeriods.form.${field}`}
          localizations={this.props.initialValues.localizations}
        />
      );
    });
  }

  setMaximumRetroactiveCredits() {
    getRetroactiveCredits(this.props.clientId, (result) => {
      this.setState({
        retroactiveCredits: result
      });
    });
  }

  generateCreditsInvoiceFrequencyOptions() {
    const nbMonthsRetroactiveLimitation = this.state.retroactiveCredits && this.state.retroactiveCredits.nbMonthsRetroactiveLimitation;
    const creditInvoiceFrequency = this.state.retroactiveCredits && this.state.retroactiveCredits.creditInvoiceFrequency;
    const options = [];
    if (nbMonthsRetroactiveLimitation && creditInvoiceFrequency) {
      // The formula to generate maximum limit is nbMonthsRetroactiveLimitation / creditInvoiceFrequency
      const maximumValueForList = nbMonthsRetroactiveLimitation / creditInvoiceFrequency;
      for (let i = 1; i <= maximumValueForList; i++) {
        if (nbMonthsRetroactiveLimitation % i === 0) {
          // We only give the multiples of maximum limit as options
          options.push({
            text: ("0" + i.toString()).slice(-2), // The key is the index + 1, converted to a string
            value: i, // The value is taken from the `values` array
          });
        }
      }
      return options;
    }
  }

  onChangeFrequency(event) {
    const creditsInvoiceFrequency = event.target.value;
    const nbMonthsRetroactiveLimitation = this.state.retroactiveCredits && this.state.retroactiveCredits.nbMonthsRetroactiveLimitation;
    // The formula to calculate creditsInvoiceCount is nbMonthsRetroactiveLimitation / creditsInvoiceFrequency ( selected value )
    const creditsInvoiceCount = (nbMonthsRetroactiveLimitation / Number(creditsInvoiceFrequency));
    this.props.changeFieldValue("billingPeriod", "creditsInvoiceCount", creditsInvoiceCount);
    this.setState({
      frequency: creditsInvoiceFrequency,
      invoiceCount: creditsInvoiceCount,
    });
  }


  render() {
    const { billingPeriodType, isArchived, isDelayed, isBillable } = this.props;
    const { isDateLocked } = this.props.initialValues;
    const isBillingRecurring = billingPeriodType == "RECURRING";
    const creditsInvoiceFrequencyOptions = this.generateCreditsInvoiceFrequencyOptions();
    const nbMonthsRetroactiveLimitationYear = this.state.retroactiveCredits.nbMonthsRetroactiveLimitation && convertMonthsToYears(this.state.retroactiveCredits.nbMonthsRetroactiveLimitation);
    return (
      <form onSubmit={this.props.handleSubmit}>
        <fieldset disabled={this.props.disabled || isBillingRecurring}>
          {this.generateLocalizedFields()}

          <Field
            id="startDate"
            name="startDate"
            component={DayPicker}
            utc={true}
            disabled={isDateLocked || isBillingRecurring}
            showClearButton={true}
            label={<FormattedMessage id="billingPeriods.form.startDate" />}
            viewMode="days"
          />

          <Field
            id="endDate"
            name="endDate"
            utc={true}
            component={DayPicker}
            disabled={isDateLocked || isBillingRecurring}
            showClearButton={true}
            label={<FormattedMessage id="billingPeriods.form.endDate" />}
            viewMode="days"
          />

          <Field
            id="hasWithdrawalPeriod"
            name="hasWithdrawalPeriod"
            component={CheckboxInput}
            disabled={isDateLocked}
            type="checkbox"
            checkbox={{ value: true }}
            label={
              <FormattedMessage id="billingPeriods.form.hasWithdrawalPeriod" />
            }
          />

          {this.props.hasWithdrawalPeriod && (
            <div>
              <Field
                id="startWithdrawalDate"
                name="startWithdrawalDate"
                utc={true}
                component={DayPicker}
                disabled={isDateLocked || isBillingRecurring}
                showClearButton={true}
                label={
                  <FormattedMessage id="billingPeriods.form.startWithdrawalDate" />
                }
                viewMode="days"
              />

              <Field
                id="endWithdrawalDate"
                name="endWithdrawalDate"
                utc={true}
                component={DayPicker}
                disabled={isDateLocked || isBillingRecurring}
                showClearButton={true}
                label={
                  <FormattedMessage id="billingPeriods.form.endWithdrawalDate" />
                }
                viewMode="days"
              />

              {!this.props.hasSessionWithdrawalForm ? (
                <div>
                  <Field
                    id="preservePreviousCoverages"
                    name="preservePreviousCoverages"
                    component={CheckboxInput}
                    disabled={isDateLocked}
                    type="checkbox"
                    checkbox={{ value: true }}
                    label={
                      <FormattedMessage id="billingPeriods.form.preservePreviousCoverages" />
                    }
                  />

                  {this.props.preservePreviousCoverages && (
                    <div>
                      <Field
                        id="relatedBillingPeriodId"
                        name="relatedBillingPeriodId"
                        component={SelectInput}
                        disabled={isDateLocked || isBillingRecurring}
                        options={this.props.allBillingPeriods.map((period) => {
                          return {
                            value: period.billingPeriodId,
                            text: `${period.localizations[this.props.authLanguageCode]
                              .name
                              } (${this.context.intl.formatDate(
                                period.startDate,
                                {
                                  year: "numeric",
                                  month: "numeric",
                                  day: "numeric",
                                  timeZone: "utc",
                                }
                              )} ${this.context.intl.formatMessage({
                                id: "common.toDate",
                              })} ${this.context.intl.formatDate(period.endDate, {
                                year: "numeric",
                                month: "numeric",
                                day: "numeric",
                                timeZone: "utc",
                              })})`,
                          };
                        })}
                        addBlankOption={true}
                        sortOptions={false}
                        label={
                          <FormattedMessage id="billingPeriods.form.billingPeriodToPreserve" />
                        }
                      />
                    </div>
                  )}
                </div>
              ) : (
                <MessageBox className="alert-info">
                  <FormattedMessage id="billingPeriods.form.warnings.hasSessionWithdrawal" />
                </MessageBox>
              )}
            </div>
          )}
        </fieldset>
        <div>
          <Field
            id="isDelayed"
            name="isDelayed"
            component={CheckboxInput}
            type="checkbox"
            checkbox={{ value: true }}
            disabled={isDelayed || this.props.disabled || isArchived}
            label={<FormattedMessage id="billingPeriods.form.isDelayed" />}
          />
          <MessageBox key="isDelayedWarning" className="alert-warning">
            <FormattedMessage id="billingPeriods.form.warnings.isDelayed" />
          </MessageBox>

          {billingPeriodType === MANUAL.value && isBillable && creditsInvoiceFrequencyOptions && (
            <span>
              <MessageBox className="alert-info">
                <FormattedMessage id="billingPeriods.form.description" values={{
                  year: nbMonthsRetroactiveLimitationYear
                }} />
              </MessageBox>
              <Field
                id="creditsInvoiceFrequency"
                name="creditsInvoiceFrequency"
                type="absNumber"
                component={SelectInput}
                required={true}
                disabled={(isDateLocked) || this.state.disableFrequencyField}
                options={creditsInvoiceFrequencyOptions}
                props={{ onChange: this.onChangeFrequency }}
                label={<FormattedMessage id="billingPeriods.form.creditsInvoiceFrequency" />}
              />
              <Field
                id="creditsInvoiceCount"
                name="creditsInvoiceCount"
                type="absNumber"
                component={TextInput}
                disabled={true}
                label={<FormattedMessage id="billingPeriods.form.creditsInvoiceCount" />}
              />
              {this.state.frequency && this.state.invoiceCount &&
                (<span className="frequency-info"><FormattedHTMLMessage id="billingPeriods.form.calculatedInformation" values={{
                  frequency: this.state.frequency,
                  invoiceCount: this.state.invoiceCount,
                  year: nbMonthsRetroactiveLimitationYear
                }} /></span>)}
            </span>
          )}
        </div>
      </form>
    );
  }
}

BasicBillingPeriodFields.propTypes = {
  allBillingPeriods: PropTypes.array,
  client: PropTypes.object,
  disabled: PropTypes.bool,
  handleSubmit: PropTypes.func,
  hasWithdrawalPeriod: PropTypes.bool,
  initialValues: PropTypes.object,
  isDelayed: PropTypes.bool,
  isDelayedState: PropTypes.bool,
  preservePreviousCoverages: PropTypes.bool,
  scene: PropTypes.string,
  validation: PropTypes.object,
  hasSessionWithdrawalForm: PropTypes.bool,
  isArchived: PropTypes.bool,
  changeFieldValue: PropTypes.func,
  authLanguageCode: PropTypes.string,
  billingPeriodType: PropTypes.string,
  creditsInvoiceCount: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  clientCreditsInvoiceFrequency: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  clientCreditsInvoiceCount: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  add: PropTypes.bool,
  isBillable: PropTypes.bool,
  clientStatusType: PropTypes.string,
  clientId: PropTypes.number,
};

BasicBillingPeriodFields.defaultProps = {
  scene: "",
};

BasicBillingPeriodFields.contextTypes = {
  intl: intlShape,
};

BasicBillingPeriodFields.childContextTypes = {
  scene: PropTypes.string,
};

function mapStateToProps(state, ownProps) {
  const selector = formValueSelector("billingPeriod");
  const client = ownProps.client ? ownProps.client : ownProps.initialValues.client;
  const billingPeriodId = ownProps.initialValues ? ownProps.initialValues.billingPeriodId : null;
  const startDate = ownProps.initialValues ? ownProps.initialValues.startDate : null;
  BasicBillingPeriodFields.client = client;
  BasicBillingPeriodFields.billingPeriodId = billingPeriodId;
  BasicBillingPeriodFields.startDate = startDate;

  return {
    hasWithdrawalPeriod: selector(state, "hasWithdrawalPeriod"),
    preservePreviousCoverages: selector(state, "preservePreviousCoverages"),
    isDelayedState: selector(state, "isDelayed"), // isDelayed form value from the redux store.
    authLanguageCode: state.auth.user.languageCode,
    billingPeriodType: state.data.clients.active.clientBillingPeriodType,
    clientStatusType: state.data.clients.active.clientStatusType,
    clientId: state.data.clients.active.clientId,
    isBillable: state.data.clients.active.isBillable,
    hasSessionWithdrawalForm:
      state.data.clients.active.hasSessionWithdrawalForm,
    isArchived: state.data.clients.active.isArchived,
    creditsInvoiceCount: selector(state, "creditsInvoiceCount")
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeFieldValue: bindActionCreators(changeFieldValue, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(
  reduxForm({
    form: "billingPeriod",
    validate: (values) =>
      validationUtils.validate(
        values,
        BasicBillingPeriodFields.generateLocalizedRules(values, BasicBillingPeriodFields.client, BasicBillingPeriodFields.billingPeriodId, BasicBillingPeriodFields.startDate)
      ),
  })(BasicBillingPeriodFields)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/billingPeriods/BasicBillingPeriodFields.js